import { render } from "./BankIcon.vue?vue&type=template&id=dda9b8d4"
const script = {}

import exportComponent from "/home/runner/work/abdom-clean-homes-booking/abdom-clean-homes-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__